export const MONTHLY_PRICE = 59;
export const FIRST_MONTH_DISCOUNT_PERCENT = 50;
export const FIRST_MONTH_PRICE = MONTHLY_PRICE * (1 - FIRST_MONTH_DISCOUNT_PERCENT / 100);
